export class KeyringNotCreatedError extends Error {
  // This gives the error type safety
  private readonly typeName = 'KeyringNotCreatedError'
  public readonly name = this.typeName

  constructor(message?: string) {
    super(message || 'Keyring does not exist')
  }
}
